<div class="layout-sidebar">
  <app-menu></app-menu>
  <div class="sidebar-bottom">
    <p-menu #menu [model]="bottomMenuItems" [hideTransitionOptions]="'0s linear'" [popup]="true" [appendTo]="'body'"></p-menu>
    <a
      #settingsBtn
      class="bottom-menu-item"
      tabindex="0"
      (click)="menu.toggle($event)"
      (keydown.enter)="menu.toggle($event)"
      (keydown.space)="menu.toggle($event)"
    >
      <app-user-avatar size="small"></app-user-avatar>
      <span class="layout-menuitem-text" *ngIf="currentUser">{{ currentUser.email }}</span>
    </a>
  </div>
</div>
